import { Box } from '@mui/material'
import MainLayout from '../../components/MainLayout'
import ResetPasswordWizzard from '../../components/wizards/ResetPasswordWizzard'

const ResetPasswordPage: React.FC = () => {
  return (
    <MainLayout className={'t-login-view'}>
      <Box sx={{ maxWidth: '442px', width: '100%' }}>
        <ResetPasswordWizzard />
      </Box>
    </MainLayout>
  )
}

export default ResetPasswordPage
